import QuickFilterController from './quick-filter.controller';
import { QuickFilterProps } from './quick-filter.model';

const QuickFilter: React.FC<QuickFilterProps> = (props) => {
  return <QuickFilterController {...props} />;
};

export default QuickFilter;
